import { render, staticRenderFns } from "./InstallList.vue?vue&type=template&id=6805223f"
import script from "./InstallList.vue?vue&type=script&lang=js"
export * from "./InstallList.vue?vue&type=script&lang=js"
import style0 from "./InstallList.vue?vue&type=style&index=0&id=6805223f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports